import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton'

import theme from '../../muiTheme';

const styles = {
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class InitialResourcesDialog extends Component
{

render() {

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Initial Resources"
       autoScrollBodyContent={true}
       maxWidth="1500px"
       open={this.props.open}>
         <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                Initial Resources
              </Typography>
              <IconButton color="inherit" onClick={this.props.onClose} style={{ position: "relative", float: "right", marginLeft: "auto" }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
              <DialogContent>
                Resources below were fulfilled within 48 hrs of incident discovery:
              <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Provider Agency</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Provider Unit</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Home Unit</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Type</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Category</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Kind</TableCell>
                        <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Code</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.initialResources && this.props.initialResources.map(resource => {
                        return (
                            <TableRow>
                                <TableCell>{resource.ProviderAgency}</TableCell>
                                <TableCell>{resource.ProviderUnit}</TableCell>
                                <TableCell>{resource.HomeUnit}</TableCell>
                                <TableCell>{resource.Type}</TableCell>
                                <TableCell>{resource.Category}</TableCell>
                                <TableCell>{resource.Kind}</TableCell>
                                <TableCell>{resource.Code}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
       </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onClose} color="primary">
          Close
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default InitialResourcesDialog;
